module.exports = __webpack_public_path__ + "img/puzzle_25.2338e102.png";